// extracted by mini-css-extract-plugin
export default {"projectsContainer":"CompletedProjects_projectsContainer__eEtTG","projectcontainer":"CompletedProjects_projectcontainer__cs0H5"};